<div class="parent">
  <mode-labeled-menu
    class="range"
    menuClass="fromto-range-menu"
    [selected]="selectedRange"
    [menuItems]="rangeOptions"
    (menuChange)="onChangeRange($event)"
  ></mode-labeled-menu>
  <ng-container *ngIf="showFixed">
    <mode-date-picker
      [date]="fixed"
      [minDate]="fixedMinDate"
      [placeholder]="fixedPlaceholder"
      (dateChange)="onChangeFixed($event)"
    ></mode-date-picker>
  </ng-container>
  <ng-container *ngIf="showValueAndPart">
    <input
      [ngModel]="value"
      (ngModelChange)="onChangeValue($event)"
      [readOnly]="valueIsReadonly"
      [tooltipIsDisabled]="!valueIsReadonly"
      [tooltipContent]="readonlyTooltipContent"
      [tooltipInteractive]="false"
      [tooltipDelay]="250"
      tooltipPlacement="bottom"
      capraTooltip
      class="form-control form-control-sm value"
      type="number"
      max="10000"
      min="1"
      step="1"
      required
    />
    <mode-labeled-menu
      menuClass="fromto-datepart-menu"
      [selected]="selectedDatePart"
      [menuItems]="datePartOptions"
      (menuChange)="onChangePart($event)"
    ></mode-labeled-menu>
  </ng-container>
</div>
